// Exports
export default {
	"conferencesForDay": "conferencesForDay_w1+-X",
	"oneColLayout": "oneColLayout_1mQtY",
	"dateNumber": "dateNumber_Pl4st",
	"date": "date_HczXv",
	"left": "left_QwT42",
	"right": "right_k4FgE",
	"confs": "confs_LkxJD"
};
